import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiPutOptions from '@/datatypes/api-put-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';
import BillingPriceCreateRequest from '@/datatypes/billing/price-create-request';
import BillingPriceUpdateRequest from '@/datatypes/billing/price-update-request';

export default class BillingPriceService extends ApiService {
  public show(billingPriceId, params = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_prices/${billingPriceId}`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public deactivate(billingPriceId) {
    return this.call(new ApiPutOptions(
      {
        url: `/billing_prices/${billingPriceId}`,
        data: {
          active: false,
        },
      },
    ));
  }

  public activate(billingPriceId) {
    return this.call(new ApiPutOptions(
      {
        url: `/billing_prices/${billingPriceId}`,
        data: {
          active: true,
        },
      },
    ));
  }

  public create(billingProductId: string, params: BillingPriceCreateRequest) {
    return this.call(new ApiPostOptions(
      {
        url: `/billing_products/${billingProductId}/billing_prices`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public update(billingPriceId: string, params: BillingPriceUpdateRequest) {
    return this.call(new ApiPutOptions(
      {
        url: `/billing_prices/${billingPriceId}`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public import(billingPriceId: string) {
    return this.call(new ApiPostOptions(
      {
        url: `/billing_prices/${billingPriceId}/import`,
        data: {},
      },
    ));
  }

  public listSubscriptions(billingPriceId: string, params = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_prices/${billingPriceId}/subscriptions`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }
}
